import React from 'react';
import { Card, Skeleton } from 'antd';

export const VendorCardSkeleton = () => (
    <Card className="card-ui">
        <Skeleton.Image 
            active 
            style={{ width: '100%', height: 160 }} 
        />
        <div className="mt-4">
            <Skeleton.Input 
                active 
                size="small" 
                style={{ width: '80%', marginBottom: 8 }} 
            />
            <Skeleton.Input 
                active 
                size="small" 
                style={{ width: '60%', marginBottom: 8 }} 
            />
            <Skeleton.Input 
                active 
                size="small" 
                style={{ width: '40%' }} 
            />
        </div>
    </Card>
);

export const MenuItemSkeleton = () => (
    <Card className="card-ui">
        <div className="flex gap-4">
            <Skeleton.Image 
                active 
                style={{ width: 80, height: 80, flexShrink: 0 }} 
            />
            <div className="flex-1">
                <Skeleton.Input 
                    active 
                    size="small" 
                    style={{ width: '70%', marginBottom: 8 }} 
                />
                <Skeleton.Input 
                    active 
                    size="small" 
                    style={{ width: '90%', marginBottom: 8 }} 
                />
                <Skeleton.Input 
                    active 
                    size="small" 
                    style={{ width: '50%' }} 
                />
            </div>
        </div>
    </Card>
);

export const TableSkeleton = ({ rows = 5, columns = 4 }) => (
    <div className="space-y-3">
        {Array.from({ length: rows }).map((_, index) => (
            <div key={index} className="flex gap-4 p-4 bg-white rounded-lg border">
                {Array.from({ length: columns }).map((_, colIndex) => (
                    <Skeleton.Input 
                        key={colIndex}
                        active 
                        size="small" 
                        style={{ 
                            width: colIndex === 0 ? '30%' : '20%',
                            height: 20 
                        }} 
                    />
                ))}
            </div>
        ))}
    </div>
);

export const DashboardStatsSkeleton = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {Array.from({ length: 4 }).map((_, index) => (
            <Card key={index} className="card-ui">
                <div className="flex items-center justify-between">
                    <div>
                        <Skeleton.Input 
                            active 
                            size="small" 
                            style={{ width: 60, height: 24, marginBottom: 8 }} 
                        />
                        <Skeleton.Input 
                            active 
                            size="small" 
                            style={{ width: 40, height: 16 }} 
                        />
                    </div>
                    <Skeleton.Avatar 
                        active 
                        size={48} 
                        shape="circle" 
                    />
                </div>
            </Card>
        ))}
    </div>
);

export const ChatMessageSkeleton = () => (
    <div className="flex gap-3 p-4">
        <Skeleton.Avatar 
            active 
            size={40} 
            shape="circle" 
        />
        <div className="flex-1">
            <Skeleton.Input 
                active 
                size="small" 
                style={{ width: '60%', marginBottom: 4 }} 
            />
            <Skeleton.Input 
                active 
                size="small" 
                style={{ width: '80%' }} 
            />
        </div>
    </div>
);

export const ListSkeleton = ({ items = 5 }) => (
    <div className="space-y-3">
        {Array.from({ length: items }).map((_, index) => (
            <div key={index} className="flex items-center gap-3 p-3 bg-white rounded-lg border">
                <Skeleton.Avatar 
                    active 
                    size={40} 
                    shape="circle" 
                />
                <div className="flex-1">
                    <Skeleton.Input 
                        active 
                        size="small" 
                        style={{ width: '70%', marginBottom: 4 }} 
                    />
                    <Skeleton.Input 
                        active 
                        size="small" 
                        style={{ width: '50%' }} 
                    />
                </div>
            </div>
        ))}
    </div>
);

export const FormSkeleton = () => (
    <Card className="card-ui">
        <div className="space-y-4">
            <Skeleton.Input 
                active 
                size="large" 
                style={{ width: '100%', height: 40 }} 
            />
            <Skeleton.Input 
                active 
                size="large" 
                style={{ width: '100%', height: 40 }} 
            />
            <Skeleton.Input 
                active 
                size="large" 
                style={{ width: '100%', height: 40 }} 
            />
            <div className="flex gap-3">
                <Skeleton.Button 
                    active 
                    size="large" 
                    style={{ width: 120, height: 40 }} 
                />
                <Skeleton.Button 
                    active 
                    size="large" 
                    style={{ width: 100, height: 40 }} 
                />
            </div>
        </div>
    </Card>
);

export default {
    VendorCardSkeleton,
    MenuItemSkeleton,
    TableSkeleton,
    DashboardStatsSkeleton,
    ChatMessageSkeleton,
    ListSkeleton,
    FormSkeleton,
};
